// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3u_1X","content":"styles_content__2wDJF","checkbox":"styles_checkbox__1rl79","checkboxLabel":"styles_checkboxLabel__2eS4H"};